export default __webpack_public_path__ + "static/media/home.e8393b65.png";